import axios from 'axios';

export const backendUrl: string | undefined = process.env.REACT_APP_API;

const client = axios.create({
  baseURL: backendUrl?.endsWith('/') ? backendUrl : `${backendUrl}/`,
});

export default client;
